import React from 'react';

export default function CustomTable({
  headers,
  children,
  config=false
}) {
  return (
    <div className={`overflow-scroll ${config ? 'h-full' : 'h-[53vh]'} pb-1`}>
      <table className='table-auto w-full'>
        <thead className='border-b-2'>
          {
            headers.map((item, index) => {
               return (<th className='whitespace-nowrap px-5 pb-2 text-xl' key={index}>{item}</th>);
            })
          }
        </thead>
        {children}
      </table>
    </div>
  );
}
